import React, { useState } from 'react';
import { Button, Modal, TextField } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

function Support() {
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Burada form verilerini işleyebilirsiniz, örneğin API'ye gönderebilirsiniz
        // Bu örnekte sadece modali açıyoruz
        setTimeout(() => {
            setModalOpen(true);
            setEmail('');
            setSubject('');
        }, 2500);
    };

    const theme = createTheme();

    return (
        <ThemeProvider theme={theme}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div style={{ background: 'white', padding: 40, borderRadius: 8, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', width: 750 }}>
                    <h2 style={{ marginBottom: 20, fontSize: 24, fontWeight: '700' }}>TenderTalk Support</h2>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            label="E-mail"
                            type="email"
                            variant="outlined"
                            fullWidth
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{ marginBottom: 20 }}
                            required
                        />
                        <TextField
                            label="Subject"
                            variant="outlined"
                            fullWidth
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            style={{ marginBottom: 20 }}
                            required
                        />
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                        >
                            Send
                        </Button>
                    </form>
                </div>
                <Modal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'white', padding: 40, borderRadius: 8, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', width: 500 }}>
                        <h2 style={{ marginBottom: 20, fontSize: 32, fontWeight: '700' }}>Your support ticket has been sended.</h2>
                        <p>You will be informed from your email about your problem in a short period of time.</p>
                        <Button
                            onClick={() => setModalOpen(false)}
                            variant="contained"
                            color="primary"
                            style={{ marginTop: 20 }}
                        >
                            Close
                        </Button>
                    </div>
                </Modal>
            </div>
        </ThemeProvider>
    );
}

export default Support;
